import { cart } from './functions'

// Document load/ready promise, calls 'ready' method when completed
HTMLDocument.prototype.ready = function () {
  return new Promise(function (resolve, reject) {
    if (document.readyState === 'complete') {
      resolve(document)
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        resolve(document)
      })
    }
  })
}

document.ready().then(function () {
  const bookPage = document.getElementById('shopify-section-product-template-books')
  if (bookPage && window.bookVariants) {
    console.log('book page')

    // let drawer = document.getElementById('sidebar-cart');
    // let closeButton = document.querySelector('#sidebar-cart .Drawer__Close');
    // let itemContainer = document.querySelector('#sidebar-cart .Drawer__Container');
    // let itemList = document.querySelector('#sidebar-cart .Cart__ItemList');
    // let overlay = document.querySelector('.PageOverlay');

    const addButton = document.querySelector('.ProductForm__AddToCartButton')
    if (addButton) {
      addButton.addEventListener('click', function (e) {
        e.preventDefault()
        document.dispatchEvent(new CustomEvent('theme:loading:start'))
        const checked = addButton.parentNode.querySelector('[checked=checked]')
        console.log(checked)
        if (checked) {
          const products = {}
          const id = Number(checked.value)
          products[id] = 1
          console.log(products)

          cart.updateCartAttributes({ updates: products }, function (cart_data) {
            console.log(cart_data)
          })
          $(window).load(function () {
            if (window.location.href.indexOf('reload') == -1) {
              window.location.replace(`${window.location.href}?reload`)
            }
          })
        } else {
          // No product options were available, use default variant
          const products = {}
          const productKey = Object.keys(window.bookVariants)[0]
          const product = window.bookVariants[productKey]
          console.log(product)
          const id = Number(product.id)

          products[id] = 1
          cart.updateCartAttributes({ updates: products }, function (cart_data) {
            console.log(cart_data)
          })
          $(window).load(function () {
            if (window.location.href.indexOf('reload') == -1) {
              window.location.replace(`${window.location.href}?reload`)
            }
          })
        }
      })
    }

    cart.updateElements()
    cart.setupCloseButton()
  }
})
